/* hoemia : mega menu PC (inspire du menu Hello Craft, adapte a la DA hoemia). Lit le menu du theme, ouvre un panneau pleine largeur : categories a gauche, puis le contenu de la categorie survolee (produits + petit mot sur la collection ou le produit), rendu par la section ho-mega-data (prix localises). Mobile : menu du theme inchange. */
(function () {
  if (window.__homm) return;
  window.__homm = true;
  var mq = window.matchMedia('(min-width: 990px)');
  var cache = {};
  var ARROW = '<svg class="homm__ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function fetchData(href) {
    var url = href.split('#')[0];
    url += (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=ho-mega-data';
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    }
    return cache[url];
  }

  function init() {
    if (!mq.matches) return;
    var nav = document.querySelector('.header__inline-menu');
    if (!nav || nav.__homm) return;
    var header = nav.closest('.header-wrapper') || nav.closest('header') || nav.parentElement;
    var items = Array.prototype.filter.call(nav.querySelectorAll(':scope > ul > li'), function (li) {
      return li.querySelector('details') && li.querySelector('.header__submenu a');
    });
    if (!items.length) return;
    nav.__homm = true;
    document.documentElement.classList.add('homm-on');

    var panel = document.createElement('div');
    panel.className = 'homm';
    panel.setAttribute('role', 'region');
    panel.innerHTML =
      '<div class="homm__inner" style="grid-template-columns:240px minmax(0,1fr)">' +
        '<div class="homm__cats"><p class="homm__kicker"></p><ul class="homm__list" role="list"></ul></div>' +
        '<div class="homm__main" aria-live="polite"></div>' +
      '</div>';
    if (getComputedStyle(header).position === 'static') header.style.position = 'relative';
    header.appendChild(panel);

    var kicker = panel.querySelector('.homm__kicker');
    var list = panel.querySelector('.homm__list');
    var main = panel.querySelector('.homm__main');
    var current = null, timer = null, token = 0;

    function setActive(a) {
      Array.prototype.forEach.call(list.querySelectorAll('.homm__cat'), function (x) { x.classList.toggle('is-active', x === a); });
      var t = ++token;
      main.classList.add('is-loading');
      fetchData(a.getAttribute('href')).then(function (html) {
        if (t !== token) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var data = tmp.querySelector('.homm-data');
        main.innerHTML = data ? data.innerHTML : '';
        main.classList.remove('is-loading');
      });
    }

    function hide() {
      panel.classList.remove('is-open');
      if (current) current.classList.remove('homm-current');
      current = null;
    }

    function open(li) {
      clearTimeout(timer);
      if (current === li && panel.classList.contains('is-open')) return;
      if (current) current.classList.remove('homm-current');
      current = li;
      li.classList.add('homm-current');
      var d = li.querySelector('details');
      if (d) d.removeAttribute('open');
      kicker.textContent = li.querySelector('summary').textContent.trim();
      list.innerHTML = '';
      Array.prototype.forEach.call(li.querySelectorAll('.header__submenu a'), function (src) {
        var item = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'homm__cat';
        a.href = src.getAttribute('href');
        a.innerHTML = '<span>' + src.textContent.trim() + '</span>' + ARROW;
        a.addEventListener('mouseenter', function () { setActive(a); });
        a.addEventListener('focus', function () { setActive(a); });
        item.appendChild(a);
        list.appendChild(item);
      });
      panel.classList.add('is-open');
      var first = list.querySelector('.homm__cat');
      if (first) setActive(first);
    }

    function close() { timer = setTimeout(hide, 160); }

    items.forEach(function (li) {
      var s = li.querySelector('summary');
      li.addEventListener('mouseenter', function () { open(li); });
      li.addEventListener('mouseleave', close);
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (current === li && panel.classList.contains('is-open')) { hide(); } else { open(li); }
      });
      var f = li.querySelector('.header__submenu a');
      if (f) li.addEventListener('mouseenter', function () { fetchData(f.getAttribute('href')); }, { once: true });
    });
    Array.prototype.forEach.call(nav.querySelectorAll(':scope > ul > li'), function (li) {
      if (items.indexOf(li) === -1) li.addEventListener('mouseenter', function () { clearTimeout(timer); hide(); });
    });
    panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
    panel.addEventListener('mouseleave', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (mq.addEventListener) mq.addEventListener('change', init);
})();
